import {
  Component,
  EventEmitter,
  Output,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import {
  FormBuilder,
  FormGroup
} from '@angular/forms';
import AlertifyHelper from 'src/app/utils/utils';
import { ToolsService } from 'src/app/utils/tools.service';
import SwalAlert from 'src/app/utils/swalalert';
import { SearchAgenciesComponent } from 'src/app/components/search-agencies/search-agencies.component';
import { BookingsService } from 'src/app/api/booking/bookings.service';
import { LoadingModalComponent } from 'src/app/components/loading-modal/loading-modal.component';
declare var $: any;

@Component({
  selector: 'app-transfers-extends',
  templateUrl: './transfers-extends.component.html',
  styleUrls: ['./transfers-extends.component.css']
})
export class TransfersExtendsComponent {
  @ViewChild(SearchAgenciesComponent) SearchAgenciesComponent: any;  
  @ViewChild(LoadingModalComponent) LoadingModalComponent: any;
  @Output() onSubmitEvent = new EventEmitter<string>();

  branchofficeSlug: string = '';
  item: FormGroup;
  submitted: boolean = false;
  isEdit: boolean = false;

  // variables
  book:any = null;
  tour:any = null;
  agencySelected:any = null;
  tours_selecteds: any = [];

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private bookingsService: BookingsService,
    private alertifyMsg: AlertifyHelper,
    public toolsService: ToolsService,
    private alert: SwalAlert
  ) {
    this.item = this.fb.group({
      booking_id: [null],
      operator_id: [null],
      observations: [null]
    });
  }

  init(book: any, tour:any) {
    this.book = book;
    this.tour = tour;
    this.tour.id = tour.detail_id;
    this.item.patchValue({
      booking_id: this.book.id
    });
    
    setTimeout(() => {
      this.SearchAgenciesComponent.focused();
    }, 1000);
  }

  selectedAgenciesSearch(item_: any) {
    this.agencySelected = item_;
    this.item.patchValue({
      operator_id: this.agencySelected.id
    });
  }

  removeAgencies() {
    this.agencySelected = null;
    this.item.patchValue({
      operator_id: null
    });
    setTimeout(() => {
      this.SearchAgenciesComponent.focused();
    }, 150);
  }

  changePriceCorporate(param: any): void {
    let value_ = param.value;    
    if (!_.isNaN(value_ * 1)) {
      this.tour.price_corporate = value_;
    }
  }

  changeDelegatedPayment(param: any): void {
    let value_ = param.value;
    if (!_.isNaN(value_ * 1)) {
      this.tour.delegated_payment = value_;
    }
  }

  preSave() {
    this.submitted = true;
    if (this.item.invalid) {
      return;
    }
    if (this.validate()) {
      let options = {
        title: '¡Atención!',
        message:
          '¿Esta seguro(a) de registrar el traspaso ?',
        cancel: 'Cancelar',
        confirm: 'Sí, CONFIRMAR TRASPASO!'
      };
      this.alert.confirmInfo(options).then((result: any) => {
        if (result.isConfirmed) {
          this.onSubmit();
        }
      });
    }
  }

  onSubmit() {
    this.tours_selecteds.push(this.tour);
    let data: any = {};
    data.book = this.item.value;
    data.tours = this.tours_selecteds;
    this.LoadingModalComponent.show();
    this.bookingsService.saveTransfers(data).subscribe({
      next: (data: any) => {
        this.onSubmitEvent.emit(data);
        this.alertifyMsg.success('Registro realizado con éxito');
        (<any>$('#openExtendsTransfers')).modal('hide');
        this.close();        
        this.LoadingModalComponent.hide();
      },
      error: (err: any) => {
        this.LoadingModalComponent.hide();
      }
    }); 
  }

  validate() {
    if (this.agencySelected == null) {
      this.alertifyMsg.warning('Debe seleccionar la agencia operadora.');
      this.SearchAgenciesComponent.focused();
      return false;
    }else{
      if(this.tour.booking_data.agency_id == this.agencySelected.id){
        let options = {
          title: '¡Advertencia!',
          message: 'No puede seleccionar la misma agencia de origen recibido, para traspasar el programa'
        };
        this.alert.warning(options);
        return false;
      }
    }
    return true;
  }

  close() {  
    this.isEdit = false;    
    this.book = null;    
    this.tour = null;    
    this.agencySelected = null;    
    this.tours_selecteds = [];    
    this.item.patchValue({
      booking_id: null,
      operator_id: null, 
      observations: null,
    });
    (<any>$('#openExtendsTransfers')).modal('hide');
    
  }

}

